import AvailableDatesCalendar from "../../entity/booking/availableDatesCalendar";

export default class AvailableDatesCalendarManager {
    constructor(sliderManager) {
        this.sliderManager = sliderManager;
        this.numDays = 0;
        this.cholloId = $('[name="id_chollo"]').val();
        this.showAvailableDatesLegend = false;
        this.showAvailabilityAlertLegend = false;
        this.cholloDateAlerts = null;
        this.availableDatesModalText = document.querySelector('#amimir_search_modal [data-entity="available-dates-modal-text"]');
        this.availableDatesModalLink = document.querySelector('#amimir_search_modal [data-entity="amimir-hotel-link"]');
        this.availableDatesModalHotelButtonContainer = document.querySelector('#amimir_search_modal [data-entity="amimir-hotel-buttons"]');
        if (this.availableDatesModalHotelButtonContainer) {
            this.availableDatesModalStayButton = this.availableDatesModalHotelButtonContainer.querySelector('[data-entity="amimir-hotel-stay"]');
            this.availableDatesModalHotelButton = this.availableDatesModalHotelButtonContainer.querySelector('[data-entity="amimir-hotel-link"]');
        }
    }

    onClickMonthEvent() {
        $('[data-entity="dates-calendar-option-container"]').on('click', event => {
            let currentTarget = $(event.currentTarget);
            let scrollHeight = currentTarget.parent().outerHeight();
            let availableDatesCalendarChildren = this.availableDatesCalendar.element.daysContainer.children;
            for (let child of availableDatesCalendarChildren) {
                if (child.dataset.entity === currentTarget.data('scroll-to')) {
                    break;
                }
                scrollHeight += child.offsetHeight;
            }
            this.monthSmoothScroll(document.querySelector('[data-calendar-container="available-dates-calendar"]'), 50, scrollHeight);
        });
    }

    monthSmoothScroll(container, height, totalHeight) {
        if (height > totalHeight) {
            container.scrollTop += 50 - (height - totalHeight);
            return;
        }
        setTimeout(() => {
            container.scrollTop += 50;
            if (height === totalHeight) {
                return;
            }
            this.monthSmoothScroll(container, height + 50, totalHeight);
        }, 10);
    }

    initialize(dates, hasApartment, startDay = null, cholloDateAlerts = null) {
        this.hasApartment = hasApartment;
        if ($('#available-dates-calendar').length === 0) {
            return;
        }

        this.cholloDateAlerts = cholloDateAlerts;
        const optionsContainerTemplate = document.querySelector('[data-entity="dates-calendar-options-container"]').cloneNode(true);
        const optionsTemplate = optionsContainerTemplate.querySelector('.swiper-wrapper');
        optionsTemplate.innerHTML = '';
        let optionTemplate = document.querySelector('[data-entity="dates-calendar-option-container"]');

        let minDate, maxDate, showMonths, startDate, endDate;
        this.dates = dates;
        let months = dates.shown_months;
        let numMonths = 0;
        this.enableDates = [];
        let showMonthOptions = Object.keys(months).length > 1;

        for (const month in months) {
            let dates = months[month].dates
            for (const date in dates) {
                if (!dates[date].inicio) {
                    continue;
                }

                if (dates[date].inicio) {
                    startDate = new Date(dates[date].inicio + 'T00:00:00');
                    if (!minDate || startDate.getTime() < minDate.getTime()) {
                        minDate = startDate;
                    }
                    if (!maxDate || startDate.getTime() > maxDate.getTime()) {
                        maxDate = startDate;
                    }
                }

                if (dates[date].min_stay || !dates[date].precio) {
                    continue;
                }

                if (dates[date].fin) {
                    endDate = new Date(dates[date].fin + 'T00:00:00');
                    if (!maxDate || endDate.getTime() > maxDate.getTime()) {
                        maxDate = endDate;
                    }

                }
                if (startDate && endDate) {
                    if (!this.numDays) {
                        let difference = endDate.getTime() - startDate.getTime();
                        this.numDays = Math.round(difference / (1000 * 3600 * 24));
                    }
                }
                this.enableDates.push(startDate);
            }

            if (months[month].min_price && showMonthOptions) {
                let option = optionTemplate.cloneNode(true);
                option.classList.remove('hide');
                let monthFormatted = month.replace('-', '/');
                option.setAttribute('data-scroll-to', monthFormatted);
                option.querySelector('[data-entity="option-title"]').textContent = new Date(month).toLocaleDateString(myApp.config.locale, {month: 'long'});
                option.querySelector('[data-entity="option-subtitle"]').textContent = months[month].min_price + ' €';
                optionsTemplate.appendChild(option);
            }
            numMonths++;
        }

        if (!minDate || !maxDate) {
            return;
        } else {
            this.minDate = minDate;
        }

        showMonths = this.monthDiff(minDate, maxDate) + 1;

        if (showMonths < 0) showMonths += 12;

        this.availableDatesCalendar = new AvailableDatesCalendar(
            'available-dates-calendar',
            document.querySelector('#available-dates-calendar'),
            '',
            this.onChangeDates.bind(this),
            () => {
                $('[data-calendar-container="available-dates-calendar"]').addClass('available-dates-calendar');
            },
            this.onDayCreate.bind(this),
            minDate,
            maxDate,
            showMonths,
            [this.isDateVisible.bind(this)]
        );

        if (!this.showAvailableDatesLegend) {
            document.querySelectorAll('[data-legend="availableDates"]').forEach(legend => {
                legend.style.display = "none";
            });
        }

        if (!this.showAvailabilityAlertLegend) {
            document.querySelectorAll('[data-legend="availabilityAlert"]').forEach(legend => {
                legend.style.display = "none";
            });
        }

        let calendarContainer = $('[data-calendar-container="available-dates-calendar"]');
        let calendarContainerParent = document.createElement('div');
        calendarContainerParent.append(optionsContainerTemplate);
        calendarContainer.prepend(calendarContainerParent);

        this.sliderManager.addSlider('[data-entity="dates-calendar-options-container"]', null, null);

        const datesCalendarLegendContainer = document.querySelector('[data-entity="dates-calendar-legend"]');
        const flatpickrContainer = calendarContainer.find('.flatpickr-rContainer');
        if (datesCalendarLegendContainer) {
            flatpickrContainer.append(datesCalendarLegendContainer);
        }

        this.resizeCalendar();
        this.onClickMonthEvent();

        if (myApp.bookingConfigurator.booking.startDate) {
            this.onChangeDates([new Date(myApp.bookingConfigurator.booking.startDate)]);
        }

        if (this.enableDates.length == 1) {
            this.onChangeDates([this.enableDates[0]]);
        }

        if (startDay) {
            const dayContainer = document.querySelector('[aria-label="' + startDay + '"]');
            if (dayContainer) {
                dayContainer.click();
            }
        }
    }


    onChangeDates(selectedDates) {
        if (this.availableDatesCalendar.isClearing) return;
        let startDate = selectedDates[0];
        if (!this.isDateEnabled(startDate)) {
            return this.unselectDates();
        }
        $('[data-action="show-calendar"]').removeClass('dates-error');
        let endDate = new Date(selectedDates[0]);
        endDate.setDate(endDate.getDate() + this.numDays);
        this.selectedRange = [startDate, endDate];
        this.availableDatesCalendar.setDate(this.selectedRange);
        this.availableDatesCalendar.jumpToDate(this.minDate);
        myApp.bookingConfigurator.setDate(startDate, endDate);

        if (this.availableDatesModalText) {
            const dateOptions = {
                month: 'long',
                day: 'numeric'
            }
            this.availableDatesModalText.innerHTML = myApp.translator['book.dates.amimir.calendar.modal.dates.text']
                .replace('@@start_date@@', startDate.toLocaleDateString(myApp.config.locale, dateOptions))
                .replace('@@end_date@@', endDate.toLocaleDateString(myApp.config.locale, dateOptions));

            if (this.availableDatesModalHotelButtonContainer) {
                this.availableDatesModalHotelButtonContainer.classList.add('flex-column-reverse');

                if (this.availableDatesModalStayButton) {
                    this.availableDatesModalStayButton.classList.remove('vpt-btn-secondary-darker-o');
                    this.availableDatesModalStayButton.classList.add('vpt-btn-complementary');
                }

                if (this.availableDatesModalHotelButton) {
                    this.availableDatesModalHotelButton.classList.remove('vpt-btn-complementary');
                    this.availableDatesModalHotelButton.classList.add('vpt-btn-secondary-darker-o');
                }
            }
        }

        if (this.availableDatesModalLink) {
            const url = new URL(this.availableDatesModalLink.href);
            url.searchParams.set('start', myApp.dateFormatter.getShortDateByDay(startDate));
            url.searchParams.set('end', myApp.dateFormatter.getShortDateByDay(endDate));
            let peopleDistribution = this.distributeRooms(myApp.bookingConfigurator.booking.adults, myApp.bookingConfigurator.booking.childrenAges);

            this.availableDatesModalLink.href = url.toString() + (peopleDistribution || '');
        }

        let inRageDays = document.querySelectorAll('.dayContainer .flatpickr-day.inRange:not(.hidden)');
        for (let day of inRageDays) {
            let date = new Date(day.getAttribute('aria-label'));
            if (this.isDateEnabled(date)) {
                let datePrice = this.getPriceByDate(new Date(date));
                if (datePrice.precio) {
                    day.innerHTML += "<span class='calendar-day-price'>" + datePrice.precio + " €</span>";
                }
                day.innerHTML += "<div class='color-primary'>•</div>";
            } else {
                day.classList.add('calendar-day-without-price');
            }
        }

        let endDayElem = document.querySelector('.dayContainer .flatpickr-day.endRange:not(.hidden)');
        if (this.isDateEnabled(endDate)) {
            let datePrice = this.getPriceByDate(new Date(endDate));
            endDayElem.innerHTML += "<span class='calendar-day-price'>" + datePrice.precio + " €</span>";
            endDayElem.innerHTML += "<div class='color-primary'>•</div>";
        } else {
            endDayElem.classList.add('calendar-day-without-price');
        }

        let datePrice = document.querySelector('.startRange .calendar-day-price').textContent;
        let datePriceText = myApp.translator['button.generic.confirm.price'].replace('%%price%%', datePrice);
        let dateContinueText = myApp.translator['button.generic.continue.price'].replace('%%price%%', datePrice);
        let continueBtnLabel = document.querySelector('label[data-entity="continue"]');

        $('[data-entity="btn-continue-calendar-container"] .btn-continue-calendar').text(datePriceText);
        $('[data-entity="continue"]').text(dateContinueText);
        if (continueBtnLabel.classList.contains('disabled')) {
            continueBtnLabel.classList.remove('disabled')
        }
        $('[data-entity="btn-continue-calendar-container"]').addClass('date-selected');
        $('.available-dates-calendar').addClass('date-selected');
        this.availableDatesCalendar.setView(true);
        myApp.step1Manager.displayNightsAlert();
    }

    onDayCreate(dObj, dStr, fp, dayElem) {
        let date = this.getPriceByDate(new Date(dayElem.dateObj));
        if (date) {
            dayElem.setAttribute('data-chollo-date-id', date.id);
            let tmpStartDate = this.selectedRange ? new Date(this.selectedRange[0].getTime()) : null;
            if (
                this.selectedRange &&
                (new Date(dayElem.dateObj)).setHours(0, 0, 0, 0) >= (tmpStartDate.setDate(tmpStartDate.getDate() + 1)) &&
                (new Date(dayElem.dateObj)).setHours(0, 0, 0, 0) <= this.selectedRange[1]
            ) {
                return;
            } else if (date.precio) {
                if (!this.hasApartment) {
                    dayElem.innerHTML += "<span class='calendar-day-price'>" + date.precio + " €</span>";
                } else {
                    let minPrice = (date.precio + (date.precio * date.min_descuento) / 100)
                    let maxPrice = (date.precio + (date.precio * date.max_descuento) / 100)
                    dayElem.innerHTML += `
                        <span class="text-s-13">${myApp.translator['calendar.prepositions.from']}</span> 
                        <span class="text-s-17">${minPrice}</span> 
                        <span class="text-s-13">${myApp.translator['calendar.prepositions.to']}</span> 
                        <span class="text-s-17">${maxPrice}</span>
                    `;
                }
            } else if (date.availabilityAlert) {
                this.showAvailabilityAlertLegend = true;
                let dayElemClass = 'calendar-day-reminder';
                if (this.cholloDateAlerts && this.cholloDateAlerts[date.id]) {
                    dayElemClass = 'calendar-day-reminder-active';
                }
                dayElem.classList.add('flatpickr-bell');
                dayElem.innerHTML += "<i class='ci-bell-fill ci-s-15 cursor-pointer " + dayElemClass + "'></i>";
                dayElem.addEventListener('click', function () {
                    if (myApp.config.isUserLoggedIn) {
                        let startDate = new Date(date.inicio);
                        let startDateNum = startDate.getDate();
                        let startDateDay = startDate.toLocaleString(myApp.config.locale, {weekday: 'long'});
                        let startDateMonth = startDate.toLocaleString(myApp.config.locale, {month: 'long'});

                        let endDate = new Date(date.fin);
                        let endDateNum = endDate.getDate();
                        let endDateDay = endDate.toLocaleString(myApp.config.locale, {weekday: 'long'});
                        let endDateMonth = endDate.toLocaleString(myApp.config.locale, {month: 'long'});

                        myApp.bookingConfigurator.showAvailabilityAlert(date.id, startDateNum, startDateDay, startDateMonth, endDateNum, endDateDay, endDateMonth);
                    } else {
                        myApp.user.loginManager.openLoginModal();
                        myApp.customModalManager.openModal('#userModal');
                    }
                }.bind(this));
            } else {
                this.showAvailableDatesLegend = true;
                dayElem.classList.add('flatpickr-min-day');
                dayElem.innerHTML += "<i class='ci ci-info ci-s-15 calendar-day-min-stay pointer'></i>";
                dayElem.addEventListener('click', function () {
                    myApp.bookingConfigurator.selectMininumStayDate(date.suggestedCategoryText ?? '', date.suggestedCholloText ?? '', date.nights, this.cholloId, date.idChollo, date.tagChollo, dayElem.getAttribute('aria-label'));
                }.bind(this));
            }
        }
    }

    getPriceByDate(currentDate) {
        currentDate.setHours(0, 0, 0, 0);

        var year = currentDate.toLocaleString("default", {year: "numeric"});
        var month = currentDate.toLocaleString("default", {month: "2-digit"});
        var day = currentDate.toLocaleString("default", {day: "2-digit"});
        let monthString = year + '-' + month;
        let dayString = year + '-' + month + '-' + day;
        let months = this.dates.shown_months;
        for (const month in months) {
            if (monthString != month) {
                continue;
            }
            let dates = months[month].dates
            for (const date in dates) {
                if (dates[date].inicio == dayString) {
                    return dates[date];
                }
            }
        }
    }

    getDateId(date) {
        let monthData = this.dates.shown_months[myApp.dateFormatter.getShortDate(date, '-', true)];
        return monthData.dates.find(d => d.inicio === myApp.dateFormatter.getShortDate(date, '-')).id;
    };

    isDateVisible(date) {
        if (
            this.selectedRange &&
            date.setHours(0, 0, 0, 0) >= this.selectedRange[0] &&
            date.setHours(0, 0, 0, 0) <= this.selectedRange[1]
        ) {
            return true;
        } else {
            return this.isDateEnabled(date);
        }
    }

    isDateEnabled(date) {
        return Boolean(this.enableDates.find(d => {
            return d.setHours(0, 0, 0, 0) === date.setHours(0, 0, 0, 0)
        }));
    }

    unselectDates() {
        delete this.selectedRange;
        this.availableDatesCalendar.clear();
        myApp.bookingConfigurator.booking.setStartDate(undefined);
        myApp.bookingConfigurator.booking.setEndDate(undefined);
        $('[data-entity=datevalue]').val('');
        $('[data-entity=dates]').hide();
        myApp.bookingConfigurator.hideContinueButton();
    }

    resizeCalendar() {
        if (this.availableDatesCalendar) {
            this.availableDatesCalendar.redraw();
            this.availableDatesCalendar.setView();
        }
    }

    monthDiff(minDate, maxDate) {
        let months;
        months = (maxDate.getFullYear() - minDate.getFullYear()) * 12;
        months -= minDate.getMonth();
        months += maxDate.getMonth();
        return months <= 0 ? 0 : months;
    }

    distributeRooms(adults, childrenAges) {
        const rooms = [];
        let remainingAdults = adults;

        if (remainingAdults === 4) {
            rooms.push(2, 2);
        } else if (remainingAdults % 3 === 0) {
            for (let i = 0; i < remainingAdults; i += 3) rooms.push(3);
        } else if (remainingAdults % 2 === 0) {
            for (let i = 0; i < remainingAdults; i += 2) rooms.push(2);
        } else {
            while (remainingAdults > 0) {
                const occupancy = Math.min(remainingAdults, 3);
                rooms.push(occupancy);
                remainingAdults -= occupancy;
            }
        }

        const numberOfRooms = rooms.length;
        if (numberOfRooms === 0) return '';

        const childrenPerRoom = Array.from({ length: numberOfRooms }, () => []);

        childrenAges.forEach((age, i) => {
            childrenPerRoom[i % numberOfRooms].push(age);
        });

        const params = rooms.flatMap((numAdults, i) => {
            const roomNumber = i + 1;
            const adultsParam = `hab${roomNumber}=${numAdults}`;
            const childrenParams = childrenPerRoom[i].map(age => `ehab${roomNumber}=${age}`);

            return [adultsParam, ...childrenParams];
        });

        return '&' + params.join('&');
    }

}
